import '@common/i18n'
import { queryClient } from '@common/queryClient'
import { ReactQueryDevtools } from '@components/devtools/TanstackReactQueryDevtools'
import { TanStackRouterDevtools } from '@components/devtools/TanStackRouterDevtools'
import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback'
import { ConfigProvider } from '@components/utils/config-provider'
import '@components/utils/reset.css'
import { ThemeProvider } from '@components/utils/theme-provider'
import { ErrorBoundary } from '@sentry/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { SnackbarProvider } from 'notistack'
import './common/sentry'
import { routeTree } from './routeTree.gen'

const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultPreload: 'intent',
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

export default function App() {
  return (
    <ErrorBoundary fallback={<ErrorBoundaryFallback />}>
      <QueryClientProvider client={queryClient}>
        <TanStackRouterDevtools
          router={router}
          initialIsOpen={false}
          position="bottom-right"
        />
        <ReactQueryDevtools
          initialIsOpen={false}
          buttonPosition="bottom-left"
        />

        <ConfigProvider>
          <ThemeProvider
            defaultTheme="light"
            storageKey="app-theme"
          >
            <SnackbarProvider
              autoHideDuration={3000}
              anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
            >
              <RouterProvider router={router} />
            </SnackbarProvider>
          </ThemeProvider>
        </ConfigProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
